import { default_dashboard } from '@core/breadcrumbs';

const index_breadcrumbs = default_dashboard
  .extend('notify.notification.index')
  .add('notify.breadcrumb.notification.title', { name: 'notify.notification.index' });

const notify_breadcrumbs = [index_breadcrumbs];

export { notify_breadcrumbs };
